module.exports = __webpack_public_path__ + "static/media/devices-min.5c0f2680.png";